import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isExecutive, isOwner, can, permissionForPath, firstAllowedRoute } from '../utils/permissions'

function ProtectedRoute({ children, requires, ownerOnly = false }) {
  const location = useLocation()
  const { isAuthenticated } = useSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (sessionStorage.getItem('needPasswordChange') === 'true') {
    return <Navigate to="/reset-password" replace />
  }

  // Owner-only page (jaise Global Settings) — staff/executive ko wapas bhej do.
  // Backend bhi requireOwner se rokta hai; ye sirf UI gate hai.
  if (ownerOnly && !isOwner()) {
    const target = firstAllowedRoute()
    return <Navigate to={target !== location.pathname ? target : '/no-access'} replace />
  }

  // Executive permission gate (cosmetic — backend is the real enforcement).
  // Only bites executives; owners/staff pass through (can() returns true).
  // `requires` prop wins; otherwise derive the key from the current path.
  if (isExecutive()) {
    const requiredKey = requires || permissionForPath(location.pathname)
    if (requiredKey && !can(requiredKey)) {
      const target = firstAllowedRoute()
      // Avoid a redirect loop if the landing target is the current page.
      if (target !== location.pathname) {
        return <Navigate to={target} replace />
      }
    }
  }

  return children
}

export default ProtectedRoute
